var _path, _path2, _path3, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGradientDesign(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 32,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.997 16.988l3.048 3.048 2.357-2.358-3.048-3.047 2.358-2.356 3.047 3.046 2.356-2.356-3.045-3.049 2.357-2.356 3.047 3.048 2.358-2.358-3.048-3.047L22.499.49a1.667 1.667 0 012.356 0l7.072 7.07a1.667 1.667 0 010 2.356L10.712 31.13a1.666 1.666 0 01-2.358 0l-7.07-7.07a1.666 1.666 0 010-2.357l4.713-4.715zm14.142 9.427l7.071-7.07 4.394 4.391v7.074h-7.07l-4.395-4.395zM5.997 12.273L1.284 7.56a1.667 1.667 0 010-2.359L5.997.488a1.667 1.667 0 012.357 0l4.716 4.713-7.073 7.072z",
    fill: "#DDD"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.997 16.988l3.048 3.048 2.357-2.358-3.048-3.047 2.358-2.356 3.047 3.046 2.356-2.356-3.045-3.049 2.357-2.356 3.047 3.048 2.358-2.358-3.048-3.047L22.499.49a1.667 1.667 0 012.356 0l7.072 7.07a1.667 1.667 0 010 2.356L10.712 31.13a1.666 1.666 0 01-2.358 0l-7.07-7.07a1.666 1.666 0 010-2.357l4.713-4.715zm14.142 9.427l7.071-7.07 4.394 4.391v7.074h-7.07l-4.395-4.395zM5.997 12.273L1.284 7.56a1.667 1.667 0 010-2.359L5.997.488a1.667 1.667 0 012.357 0l4.716 4.713-7.073 7.072z",
    fill: "url(#paint0_linear_3833_2876)",
    fillOpacity: 0.85
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M5.997 16.988l3.048 3.048 2.357-2.358-3.048-3.047 2.358-2.356 3.047 3.046 2.356-2.356-3.045-3.049 2.357-2.356 3.047 3.048 2.358-2.358-3.048-3.047L22.499.49a1.667 1.667 0 012.356 0l7.072 7.07a1.667 1.667 0 010 2.356L10.712 31.13a1.666 1.666 0 01-2.358 0l-7.07-7.07a1.666 1.666 0 010-2.357l4.713-4.715zm14.142 9.427l7.071-7.07 4.394 4.391v7.074h-7.07l-4.395-4.395zM5.997 12.273L1.284 7.56a1.667 1.667 0 010-2.359L5.997.488a1.667 1.667 0 012.357 0l4.716 4.713-7.073 7.072z",
    fill: "url(#paint1_linear_3833_2876)",
    fillOpacity: 0.85
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_3833_2876",
    x1: -0.7,
    y1: 31.619,
    x2: 32.415,
    y2: 31.619,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.385,
    stopColor: "#DD0510"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.958,
    stopColor: "#7D0006"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_3833_2876",
    x1: -0.7,
    y1: 31.619,
    x2: 32.415,
    y2: 31.619,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A6C0FE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F68084"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGradientDesign);
export default __webpack_public_path__ + "static/media/gradient-design.65398aa0ab2e81cc92f0b4d5ceb07d1e.svg";
export { ForwardRef as ReactComponent };